import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "./Reveal";
import { SERVICES, WA_LINK, IMAGES } from "../site";

export const Services = () => (
  <section id="services" data-testid="services-section" className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
    <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
      <div className="md:col-span-5">
        <Reveal>
          <Overline>The Rituals</Overline>
          <h2 className="mt-6 font-serif font-light tracking-tight leading-tight text-4xl sm:text-5xl md:text-6xl text-stone-100">
            A menu of<br /><span className="italic text-gold-300">quiet luxury</span>
          </h2>
          <p className="mt-8 max-w-sm text-base md:text-lg font-light leading-relaxed text-stone-300">
            Every treatment is tailored on the day — pressure, oils, pace. Choose your ritual, then message us to reserve your room.
          </p>
        </Reveal>
        <Reveal delay={0.15} className="mt-12 hidden md:block">
          <div className="relative w-72 aspect-[3/4] overflow-hidden rounded-sm">
            <motion.img
              src={IMAGES.stones}
              alt="Hot stone massage therapy with white flowers"
              className="w-full h-full object-cover"
              whileHover={{ scale: 1.06 }}
              transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            />
            <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
          </div>
        </Reveal>
      </div>

      <div className="md:col-span-7">
        {SERVICES.map((s, i) => (
          <Reveal key={s.name} delay={i * 0.06}>
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid={`service-book-${i}`}
              className="group flex items-baseline gap-4 py-7 md:py-8 border-b border-white/10 hover:border-gold-400/50 transition-colors duration-500"
            >
              <span className="text-xs font-semibold tracking-[0.2em] text-gold-400 shrink-0">0{i + 1}</span>
              <div className="flex-1 min-w-0">
                <div className="flex items-baseline gap-3">
                  <h3 className="font-serif text-2xl md:text-3xl font-medium tracking-tight text-stone-100 group-hover:text-gold-300 transition-colors duration-500 truncate">
                    {s.name}
                  </h3>
                  <span className="flex-1 border-b border-dotted border-white/20 -translate-y-1 hidden sm:block" />
                  <span className="text-base md:text-lg text-gold-400 font-medium shrink-0">{s.price}</span>
                </div>
                <p className="mt-2 text-sm md:text-base font-light text-stone-400">{s.desc} · {s.duration}</p>
              </div>
              <ArrowUpRight className="w-5 h-5 text-stone-500 group-hover:text-gold-400 group-hover:translate-x-1 group-hover:-translate-y-1 transition-all duration-500 shrink-0 self-center" />
            </a>
          </Reveal>
        ))}
        <Reveal delay={0.2}>
          <p className="mt-8 text-sm text-stone-500 font-light">
            Prices are indicative — tap any ritual to confirm today's availability on WhatsApp.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
